<template>
  <div class="container">
    <div class="form-wrapper">
      <Logo />
      <v-alert v-if="isMerchantClosed" type="error" class="mb-4">
        Merchant Account is closed
      </v-alert>
      <v-form @submit.prevent="attemptLogin" class="rounded-lg">
        <h2 style="text-align: center">Login</h2>
        <PageLoader ref="loader">
          <TextInput
            v-model="username"
            name="username"
            label="User name"
            placeholder="User name"
            :errors="validationErrors"
            :autofocus="true"
            required
            dense
          />
          <TextInput
            dense
            v-model="password"
            name="password"
            label="Password"
            placeholder="Password"
            :errors="validationErrors"
            :inputType="showPassword ? InputTypes.TEXT : InputTypes.PASSWORD"
          />
          <!-- Show Password Checkbox -->
          <div class="text-left" style="margin-top: -15px;">
            <v-checkbox
              v-model="showPassword"
              label="Show Password"
              dense
              hide-details
            />
          </div>
          <v-card-actions>
            <v-col class="text-left pa-0">
              <router-link v-if="!isMerchantClosed"
                :to="{ name: `password-reset` }"
              >
              Forgot Password?
              </router-link>
            </v-col>

            <v-col class="text-right pa-0">
              <v-btn right color="success" class="mr-4" type="submit" :disabled="isMerchantClosed"> Login </v-btn>
            </v-col>
          </v-card-actions>
        </PageLoader>
      </v-form>
    </div>
    <v-footer
      v-if="showCoreCommerceFooter"
      app
      padless
      color="transparent"
    >
      <v-col class="text-center py-3" cols="12">
        <a href="https://corecommerce.com/" target="_blank" rel="noopener noreferrer">
          Powered by CoreCommerce
        </a>
      </v-col>
    </v-footer>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import TextInput from '@/common/components/forms/TextInput.vue';
import Logo from '@/common/components/Logo.vue';
import PageLoader from '@/common/components/PageLoader.vue';
import { mapGetters } from 'vuex';
import { ValidationErrors } from '@/common/validation/validation.types';
import { InputTypes } from '@/common/types/input.types';
import { MerchantStatus } from '@/iso/views/merchants/merchants.types';

export default Vue.extend({
  data() {
    return {
      title: 'Login' as string,
      username: '' as string,
      password: '' as string,
      showPassword: false as boolean,
      validationErrors: {} as ValidationErrors,
      InputTypes,
    };
  },
  created() {
    if (this.title) {
      document.title = this.title;
    }
  },
  mounted() {
    (this.$refs as any).loader.setReady();
  },
  computed: {
    ...mapGetters(['context']),
    queryString(): string {
      return window.location.href.split('?')[1];
    },
    isMerchantClosed(): boolean {
      return this.$store.state.branding?.merchantStatus === MerchantStatus.CLOSED;
    },
    showCoreCommerceFooter(): boolean {
      return [
        'huntington.mypaymentnow.com',
        'ltc-pharmacy-llc.mypaymentnow.com',
        'huntington.cgatewaysandbox.com',
      ].includes(window.location.hostname);
    },
  },
  methods: {
    attemptLogin() {
      (this.$refs as any).loader.setLoading();
      this.$store
        .dispatch('login', {
          username: this.username,
          password: this.password,
        })
        .then(() => {
          this.$router.push(this.$store.getters.redirect || { name: `${this.context}.dashboard` });
        })
        .catch(this.showLoginErrors);
    },
    showLoginErrors({ response: { data: response } }: { response: any }) {
      (this.$refs as any).loader.setReady();
      this.validationErrors = response?.errors || {};
    },
  },
  components: {
    Logo,
    PageLoader,
    TextInput,
  },
});
</script>
